module.exports = __webpack_public_path__ + "img/b_immun_front.57920a24.jpeg";